import { useCallback, useEffect, useState } from 'react'

import { getUserSelectedRegionId } from '@sportworld/js-sdk/src/actions/region'
import { cdn, isDevMode } from '@sportworld/js-sdk/src/envs/envs'

import { getRegionInfo } from '@/actions/region'
import { overrideRegionIds } from '@/constants/common'
import { ApiService } from '@/service'
import { SelectOptionType } from '@/types/componentsPropsTypes'
import { RegionIdType } from '@/types/servicesTypes/configTypes'

const autoRegionSelect = 'auto'
const autoOption = { id: autoRegionSelect, label: autoRegionSelect }

export const useFetchAvailableRegions = () => {
  const [selectedRegionId, setSelectedRegionId] = useState<string>('')
  const [availableRegionOptions, setAvailableRegionOptions] = useState<
    Array<SelectOptionType>
  >([])
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<boolean>(false)

  const requestAction = useCallback(async () => {
    setError(false)
    setLoading(true)
    const regionInfo = await getRegionInfo()
    let availableRegionIds = regionInfo.availableRegionIds || []

    if (isDevMode) {
      availableRegionIds = [
        ...availableRegionIds,
        ...overrideRegionIds.filter((el) => !availableRegionIds?.includes(el)),
      ]
    }

    if (availableRegionIds?.length) {
      const userSelectedRegionId = getUserSelectedRegionId(
        regionInfo.availableRegionIds,
      )
      Promise.all(availableRegionIds?.map((id) => ApiService.getRegionById(id)))
        .then((availableRegions) => {
          const availableRegionOptions = availableRegions.map(
            (el: RegionIdType) => {
              return {
                id: el.id,
                label: el.name || el.id,
                imageSrc: el.countryCodes[0]
                  ? `${cdn}/flags/4x3/${el.countryCodes[0].toLocaleLowerCase()}.svg`
                  : '',
              }
            },
          )
          setAvailableRegionOptions([autoOption, ...availableRegionOptions])
          setSelectedRegionId(userSelectedRegionId || autoRegionSelect)
          setLoading(false)
        })
        .catch(() => {
          setError(true)
        })
    } else {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    requestAction()
  }, [])

  return {
    loading,
    availableRegionOptions,
    selectedRegionId,
    error,
    setSelectedRegionId,
    requestAction,
  }
}
